/**
 * @generated SignedSource<<427cf548cb47f6277fe247c28b88c619>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingPaymentGiftCard_SquareGiftCard$data = {
  readonly balance: number;
  readonly ganLastFour: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "BookingPaymentGiftCard_SquareGiftCard";
};
export type BookingPaymentGiftCard_SquareGiftCard$key = {
  readonly " $data"?: BookingPaymentGiftCard_SquareGiftCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentGiftCard_SquareGiftCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingPaymentGiftCard_SquareGiftCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ganLastFour",
      "storageKey": null
    }
  ],
  "type": "SquareGiftCard",
  "abstractKey": null
};

(node as any).hash = "b2e0e4f62658c6bceffa0b6610a5f798";

export default node;
